import { Button } from '@talentmesh/ui/components/button';
import { Star, StarOff } from 'lucide-react';
import { useCandidatesOverviewContext } from '../../CandidatesOverviewContext/CandidatesOverviewContext';
import { CellProps } from '.';
import UIStrings from '@/Utils/UIStrings';

function FavoriteCell({ candidate: { candidateId, isFavorite } }: CellProps) {
    const { saveFavoriteAsync } = useCandidatesOverviewContext();

    const handleFavoriteOnClick = () => {
        saveFavoriteAsync(candidateId, !isFavorite);
    };

    return (
        <Button
            variant="ghost"
            size="icon-sm"
            type="button"
            aria-label={UIStrings.Favorite}
            aria-pressed={isFavorite}
            onClick={handleFavoriteOnClick}
            className="group text-primary hover:text-primary mx-auto"
        >
            <span className="relative inline-flex size-6 items-center justify-center">
                {isFavorite ? (
                    <>
                        <Star
                            aria-hidden
                            className="transition-opacity group-hover:pointer-events-none group-hover:opacity-0"
                            fill="currentColor"
                        />
                        <StarOff
                            aria-hidden
                            className="pointer-events-none absolute inset-0 m-auto opacity-0 transition-opacity group-hover:pointer-events-auto group-hover:opacity-100"
                        />
                    </>
                ) : (
                    <>
                        <Star
                            aria-hidden
                            className="transition-opacity group-hover:pointer-events-none group-hover:opacity-0"
                        />
                        <Star
                            aria-hidden
                            className="pointer-events-none absolute inset-0 m-auto opacity-0 transition-opacity group-hover:pointer-events-auto group-hover:opacity-100"
                            fill="currentColor"
                        />
                    </>
                )}
            </span>
        </Button>
    );
}

export default FavoriteCell;
